import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem
import qs from 'qs'

// 请购单审批记录
export function requestApprovedList(data) {
    return request({
        url: serviceName + `/request_approved_list` + '?' + qs.stringify(data),
        method: 'get',
        data: data
    })
}
